import { NONE_OPTION } from 'components/selects/selects';

/**
 * Optional own active-inflect template of a compound.
 * null (or missing) = the compound's active cells are the intersection of its member panels' templates.
 */
export const COMPOUND_INFLECT_TEMPLATE_KEY = 'activeInflectTemplateId';

export const COMPOUND_INFLECT_TEMPLATE_NONE_LABEL = 'From panels (intersection)';

/** API value: unset / empty option (NONE_OPTION.id) -> null, which clears the field. */
export const normalizeCompoundTemplateId = (value: number | null | undefined): number | null =>
  !value || value === NONE_OPTION.id ? null : value;
